import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_BASE = `${BACKEND_URL}/api`;

// Create axios instance with default config
const api = axios.create({
  baseURL: API_BASE,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to add auth token if available
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('admin_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Clear token on unauthorized
      localStorage.removeItem('admin_token');
    }
    return Promise.reject(error);
  }
);

// Vehicle API
export const vehicleAPI = {
  // Get all vehicles with optional filters
  getVehicles: async (filters = {}) => {
    const params = new URLSearchParams();
    Object.keys(filters).forEach(key => {
      if (filters[key] !== null && filters[key] !== undefined && filters[key] !== '') {
        params.append(key, filters[key]);
      }
    });
    
    const response = await api.get(`/vehicles/?${params.toString()}`);
    return response.data;
  },

  // Get single vehicle by ID
  getVehicleById: async (id) => {
    const response = await api.get(`/vehicles/${id}/`);
    return response.data;
  },

  // Create new vehicle (Admin only)
  createVehicle: async (vehicleData) => {
    const response = await api.post('/vehicles/', vehicleData);
    return response.data;
  },

  // Update vehicle (Admin only)
  updateVehicle: async (id, vehicleData) => {
    const response = await api.put(`/vehicles/${id}/`, vehicleData);
    return response.data;
  },

  // Delete vehicle (Admin only)
  deleteVehicle: async (id) => {
    const response = await api.delete(`/vehicles/${id}/`);
    return response.data;
  },
};

// Contact API
export const contactAPI = {
  // Submit contact form
  submitContact: async (contactData) => {
    const response = await api.post('/contact/', contactData);
    return response.data;
  },

  // Get all contacts (Admin only)
  getContacts: async (filters = {}) => {
    const params = new URLSearchParams();
    Object.keys(filters).forEach(key => {
      if (filters[key] !== null && filters[key] !== undefined && filters[key] !== '') {
        params.append(key, filters[key]);
      }
    });
    
    const response = await api.get(`/contact/?${params.toString()}`);
    return response.data;
  },

  // Update contact status (Admin only)
  updateContactStatus: async (id, status) => {
    const response = await api.put(`/contact/${id}/`, { status });
    return response.data;
  },
};

// Admin API
export const adminAPI = {
  // Admin login
  login: async (credentials) => {
    const response = await api.post('/admin/login/', credentials);
    return response.data;
  },

  // Get dashboard stats
  getDashboardStats: async () => {
    const response = await api.get('/admin/dashboard/');
    return response.data;
  },

  // Get admin inquiries
  getInquiries: async () => {
    const response = await api.get('/admin/inquiries/');
    return response.data;
  },

  // Get current admin info
  getCurrentAdmin: async () => {
    const response = await api.get('/admin/me/');
    return response.data;
  },
};

// Health check
export const healthAPI = {
  check: async () => {
    const response = await api.get('/health/');
    return response.data;
  },
};

export default api;